import { PageRenderer } from "@/components/page-renderer";
import { LocationHero } from "./location-hero";
import { SellSupplyInstall, LocalContent, SectorsB2B, DeliveryBand } from "./location-sections";
import { placeName, type LocationCtx } from "./location-data";
import { ProjectGallery } from "./project-gallery";

export function LocationPage({ ctx, blocks, fallbackTitle }: { ctx: LocationCtx; blocks: any[]; fallbackTitle: string }) {
  const list = Array.isArray(blocks) ? blocks : [];
  // Lift a leading CMS hero / h1 heading into our hero to avoid duplicate h1s.
  const first = list[0];
  let title = `${ctx.service.title} in ${placeName(ctx)}`;
  let rest = list;
  if (first?.type === "heading" && (first.level || 2) === 1 && first.text) { title = first.text; rest = list.slice(1); }
  else if (first?.type === "hero" && first.title) { title = first.title; rest = list.slice(1); }
  else if (fallbackTitle && !fallbackTitle.includes("|")) title = fallbackTitle;
  return (
    <>
      <LocationHero ctx={ctx} title={title} />
      <SellSupplyInstall ctx={ctx} />
      <ProjectGallery key={ctx.service.slug || ctx.service.title} ctx={ctx} />
      {rest.length > 0 && (
        <LocalContent ctx={ctx}>
          <div className="[&_h2]:mt-4 [&_h3]:mt-2"><PageRenderer blocks={rest} context={ctx as any} /></div>
        </LocalContent>
      )}
      <SectorsB2B ctx={ctx} />
      <DeliveryBand ctx={ctx} />
    </>
  );
}
